import React from "react"

const Translate = class extends React.Component {
  componentDidMount() {
    const translateScript1 = document.createElement("script");
    translateScript1.async = true;
    translateScript1.innerText = `function googleTranslateElementInit() { new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element'); }`;
    document.body.appendChild(translateScript1);
    const translateScript2 = document.createElement("script");
    translateScript2.async = true;
    translateScript2.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(translateScript2);
  }
  render() {
    const { isActive } = this.props;
    return (
      <>
        <div
          className="flex items-start font-normal target my-4 rounded-md"
        >
          <h2 className="sr-only" id="translate">Language Translation</h2>
          <div className="relative">
            <div
              className="relative"
              dangerouslySetInnerHTML={{
                __html: "",
              }}
              id="google_translate_element"
            ></div>
            <span className={`target-icon -top-2 -right-2 absolute w-3 h-3 ${isActive ? "" : "hidden"}`}>
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green"></span>
            </span>
          </div>
        </div>
      </>
    );
  }
}
export default Translate